const findItemByIdIriFromArray = (idIri: string, items: IIdIri[]) => {
  const item = items.find((f) => f.idIri === idIri);

  return item ? item : null;
};

export { findItemByIdIriFromArray };
